import * as React from 'react';
import IconBase, { type TIconBaseProps, Example as IconBaseExample } from '@atlas/uicorn/lib/Icon/IconBase';
import { defineMessages, useIntl } from '@atlas/text';

export const messages = defineMessages({
    codeBlock: { id: 'lblIconCodeBlock', defaultMessage: 'Code Block' },
});

const CodeBlockIcon = React.memo(function CodeBlockIcon(props: TCodeBlockIconProps): React.ReactElement {
    const intl = useIntl();

    return (
        <IconBase aria-label={intl.formatMessage(messages.codeBlock)} {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.15 4.5H17V17H4.49999V13.9C4.49999 13.6791 4.3209 13.5 4.09999 13.5H3.39999C3.17907 13.5 2.99999 13.6791 2.99999 13.9V17.25C2.99999 17.9404 3.55963 18.5 4.24999 18.5H17.25C17.9403 18.5 18.5 17.9404 18.5 17.25V4.25C18.5 3.55964 17.9403 3 17.25 3H14.15C13.9291 3 13.75 3.17909 13.75 3.4V4.1C13.75 4.32091 13.9291 4.5 14.15 4.5ZM5.11108 5.36109L3.11108 7.36109L2.72217 7.75L3.11108 8.13891L5.11108 10.1389L5.88889 9.36109L4.2778 7.75L5.88889 6.13891L5.11108 5.36109ZM12.3889 7.36109L10.3889 5.36109L9.61108 6.13891L11.2222 7.75L9.61108 9.36109L10.3889 10.1389L12.3889 8.13891L12.7778 7.75L12.3889 7.36109ZM9.2251 4.20675C9.26922 4.04749 9.14943 3.89001 8.98418 3.89001H8.44014C8.32777 3.89001 8.22922 3.96498 8.19921 4.07326L6.3376 10.7921C6.29352 10.9512 6.41303 11.1086 6.57812 11.1088L7.12236 11.1097C7.23488 11.1099 7.33366 11.0349 7.36369 10.9264L9.2251 4.20675Z"
            />
        </IconBase>
    );
});

export default CodeBlockIcon;

// #region Types

export type TCodeBlockIconProps = Omit<TIconBaseProps, 'children' | 'aria-label'> &
    Partial<Pick<TIconBaseProps, 'aria-label'>>;

// #endregion

// #region Examples

export const Example =
    typeof IconBaseExample === 'function' ? () => <CodeBlockIcon /> : { ...IconBaseExample, render: CodeBlockIcon };

// #endregion
